export const queryKeys = {
  //example
  // user: ['user'] as const,
  // memberStatus: (email: string) => ['memberStatus', email] as const,
};
